var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.646 3.48a.5.5 0 0 0 0 .707l3.182 3.182a.5.5 0 1 0 .708-.707L1.707 3.833l2.829-2.828a.5.5 0 1 0-.708-.707L.646 3.48ZM41 3.333H1v1h40v-1Z",
    fill: "#30384C"
  })));
};
export default SvgArrowBack;